<template>
    <div>
        <div class="d-inline-flex align-center">
            <v-btn v-if="!running"
                   @click="startTimer"
                   :loading="loading"
                   color="orange-darken-1"
                   variant="flat"
                   size="large"
                   class="mr-2">
                <v-icon icon="mdi-coffee" class="mr-1"></v-icon> Start Break
            </v-btn>
            <v-btn v-if="running"
                   @click="stopTimer"
                   :loading="loading"
                   color="red-darken-1"
                   variant="flat"
                   size="large"
                   class="mr-2">
                <v-icon icon="mdi-stop-circle" class="mr-1"></v-icon> Stop Break <span class="ml-2">{{ runningTime }}</span>
            </v-btn>
        </div>
        <small v-if="!running" class="text-grey-lighten-1">Starting a break will pause any running job timers.</small>
    </div>
</template>
<script>
    import { mapActions } from "vuex";
    function initialState() {
        return {
            loading: false,
            timer: null,
            seconds: 0,
            minutes: 0,
            hours: 0
        };
    }
    export default {
        name: "TaskTimerButtons",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.updateTimer();
            }, 1000);
        },
        beforeUnmount: function () {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        props: {
            status: Number,
            type: Number,
            activeBreak: Object,
            refresh: Number
        },
        methods: {
            ...mapActions([
                "showErrorSnack"
            ]),
            startTimer() {
                this.loading = true;
                this.$api.post(`/dashboard/starttasktimer?type=${this.type}&status=${this.status}`)
                    .then(res => {
                        this.loading = false;
                        this.$emit('update:activeBreak', res.data);
                        this.$emit('update:refresh', this.refresh + 1);
                    }).catch(() => {
                        this.loading = false;
                        this.showErrorSnack("Failed to start break timer.");
                    });
            },
            stopTimer() {
                if (!this.activeBreak) return;
                this.loading = true;
                this.$api.post(`/dashboard/endtasktimer?id=${this.activeBreak.id}`)
                    .then(() => {
                        this.loading = false;
                        this.$emit('update:activeBreak', null);
                        this.$emit('update:refresh', this.refresh + 1);
                    }).catch(() => {
                        this.loading = false;
                        this.showErrorSnack("Failed to stop break timer.");
                    });
            },
            updateTimer() {
                this.seconds = 0;
                this.minutes = 0;
                this.hours = 0;
                if (this.running && this.activeBreak.startTime) {
                    var timeDiff = this.$dayjs().diff(this.$dayjs(this.activeBreak.startTime));
                    this.seconds = Math.floor((timeDiff / 1000) % 60);
                    this.minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
                    this.hours = Math.floor((timeDiff / (1000 * 60 * 60)));
                }
            }
        },
        computed: {
            running() {
                return this.activeBreak != null && this.activeBreak.id != null;
            },
            runningTime() {
                return this.hours.toString().padStart(2, "0") + ":" + this.minutes.toString().padStart(2, "0") + ":" + this.seconds.toString().padStart(2, "0");
            }
        }
    };
</script>
